import { render, staticRenderFns } from "./private-fl44-unknown-volume-contract-customer-block.vue?vue&type=template&id=55cf8d7f&"
import script from "./private-fl44-unknown-volume-contract-customer-block.vue?vue&type=script&lang=js&"
export * from "./private-fl44-unknown-volume-contract-customer-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55cf8d7f')) {
      api.createRecord('55cf8d7f', component.options)
    } else {
      api.reload('55cf8d7f', component.options)
    }
    module.hot.accept("./private-fl44-unknown-volume-contract-customer-block.vue?vue&type=template&id=55cf8d7f&", function () {
      api.rerender('55cf8d7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-contract-customer-block.vue"
export default component.exports